import script from "./FormulasTopActions.vue?vue&type=script&setup=true&lang=js"
export * from "./FormulasTopActions.vue?vue&type=script&setup=true&lang=js"

import "./FormulasTopActions.vue?vue&type=style&index=0&id=b8bba284&lang=scss"

const __exports__ = script;

export default __exports__